import logo from '../Arkane-logo.webp'
function Footer() {
    return (
          <footer className="footer">
          <div className="base-container w-container">
           
              <div className="footer-wrapper">
                  <div className="left-content-footer"><a
                          href="/" aria-current="page" className="footer-brand w-nav-brand w--current"><img src={logo}
                              loading="lazy" alt="Logo" height="30" className="footer-logo" /></a>
                      <div class="socila-media">
                            <a target="_blank" rel="noreferrer" href="https://www.facebook.com/profile.php?id=61584838861510"><i className="fab fa-facebook-f"></i></a>
                            <a target="_blank" rel="noreferrer" href="https://x.com/ArkaneEngi37143"><i className="fab fa-x-twitter"></i></a>
                            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/arkaneengineering/"><i className="fab fa-instagram"></i></a>
                            <a target="_blank" rel="noreferrer" href=" https://www.linkedin.com/company/arkn-engineering/"><i className="fab fa-linkedin"></i></a>
                      </div>

                  </div>
                  {/* <div className="subscribe-wrap">

                  </div> */}
                  <div className="links-footer-wrapper">

                      <div className="link-pages">
                          <a href="/">Home</a>
                          <a href="/about-arkane">About</a>
                          <a href="/arkane-services">Services</a>
                          {/* <a href="/arkane-clients">Clients</a> */}
                          <a href="/arkane-team">Team</a>
                           <a href="/arkane-career">Career</a>
                          <a href="/contact-arkane">Contact</a>
                      </div>
                      <div data-w-id="5c5755d2-bf55-44a7-6173-837626efdc75" class="contacts-divider"></div>
                      {/* <div className="info-footer">
                          <div className="info-wrap">
                              Contact: <a href="tel:080-28282221" className="number">080-28282221</a> / <a href="tel:+919187650900" className="number">+91 9187650900</a>
                          </div>

                          <div className="info-wrap">
                             Mail:<a href="mailto:info@arkane.in" className="number">info@arkane.in</a>
                          </div>

                          <div className="info-wrap">
                              Location: <div className="location">Bengaluru, Karnataka</div>
                          </div>
                      </div> */}
                      {/* <div data-w-id="5c5755d2-bf55-44a7-6173-837626efdc75" class="contacts-divider"></div> */}
                      <div className="footer-rights-wrapper">
                          <div className="footer-copyright">© Mystra All Rights Reserved.</div>

                      </div>
                  </div>
              </div>
          </div>
      </footer>
    )
}

export default Footer;